module.exports = __webpack_public_path__ + "static/media/06_sognolucido.231132df.jpg";